import React from 'react';
import { StyleSheet, css } from "../../styles/theme";
var styles = StyleSheet.create({
  badge: {
    fontSize: 12,
    "float": 'right',
    fontWeight: 'bold',
    fontFamily: 'OpenSans',
    width: 'fit-content',
    textDecoration: 'none',
    color: 'black',
    backgroundColor: '#FFE057',
    borderRadius: '10px',
    padding: '0px 15px',
    verticalAlign: 'middle'
  }
});
export default function TagBadge(_ref) {
  var text = _ref.text;
  return React.createElement("div", css('rc-TagBadge'), React.createElement("span", css(styles.badge), text));
}